import DOMPurify, { Config } from 'dompurify';

export const capitalizeFirstLetter = (string: string) =>
  string.charAt(0).toUpperCase() + string.slice(1);

export const uniqueIdGenerator = (length: number) => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
};

export const truncateString = (string: string, length: number, end = '...') => {
  if (string) {
    return string.length < length ? string : string.substring(0, length) + end;
  }

  return '';
};

export const sanitizeHtml = (content: string): string => DOMPurify.sanitize(content);
